import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import AutosRelifDetailSection from 'pages/AutosRelif/LandingPage/CarDetails';
import type { ReactNode } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { type AutosRelifCar, useGetAutosRelifCarsQuery } from 'services/api/autosrelif.api';

const BACKGROUND_COLOR = '#f7fafc';
const BASE_COLOR = '#021024';
const ACCENT_COLOR = '#FFCC00';

const CenteredState = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      background: BACKGROUND_COLOR,
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 3,
      px: 3,
      textAlign: 'center',
    }}
  >
    {children}
  </Box>
);

const AutosRelifCarDetailPage = () => {
  const { hash } = useParams<{ hash: string }>();
  const navigate = useNavigate();
  const { data, isLoading } = useGetAutosRelifCarsQuery();

  const goToListing = () => navigate('/autosrelif');

  if (isLoading) {
    return (
      <CenteredState>
        <CircularProgress sx={{ color: BASE_COLOR }} />
      </CenteredState>
    );
  }

  const allCars: AutosRelifCar[] = [...(data?.newCars ?? []), ...(data?.usedCars ?? [])];
  const car = hash ? allCars.find((currentCar) => currentCar.hash === hash) : undefined;

  if (!car) {
    return (
      <CenteredState>
        <Typography variant="h5" sx={{ fontWeight: 700, color: BASE_COLOR }}>
          No encontramos este vehículo
        </Typography>
        <Typography sx={{ color: 'text.secondary', maxWidth: 480 }}>
          Puede que ya no esté disponible. Revisa el resto de nuestro catálogo.
        </Typography>
        <Button
          variant="contained"
          onClick={goToListing}
          sx={{ backgroundColor: BASE_COLOR, '&:hover': { backgroundColor: ACCENT_COLOR } }}
        >
          Ver catálogo
        </Button>
      </CenteredState>
    );
  }

  return <AutosRelifDetailSection car={car} onClose={goToListing} />;
};

export default AutosRelifCarDetailPage;
